// import React, { useState, useEffect } from "react";
// import Modal from "react-modal";
// import { FaEdit, FaTrash } from "react-icons/fa";

// Modal.setAppElement("#root");

// export default function FoodMenu() {
//   const [menu, setMenu] = useState([]);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [editingId, setEditingId] = useState(null);

//   const [formData, setFormData] = useState({
//     name: "",
//     isVeg: true,
//     cuisine: "",
//     category: "starters",
//     price: "",
//   });

//   // Load from localStorage
//   useEffect(() => {
//     const saved = localStorage.getItem("menuData");
//     if (saved) setMenu(JSON.parse(saved));
//   }, []);

//   // Save to localStorage
//   useEffect(() => {
//     localStorage.setItem("menuData", JSON.stringify(menu));
//   }, [menu]);

//   const openModal = (item = null) => {
//     if (item) {
//       setFormData(item);
//       setEditingId(item.id);
//     } else {
//       setFormData({
//         name: "",
//         isVeg: true,
//         cuisine: "",
//         category: "starters",
//         price: "",
//       });
//       setEditingId(null);
//     }
//     setIsModalOpen(true);
//   };

//   const closeModal = () => setIsModalOpen(false);

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData({
//       ...formData,
//       [name]: type === "checkbox" ? checked : value,
//     });
//   };

//   // Save or update item
//   const handleSave = () => {
//     if (!formData.name || !formData.price) {
//       alert("Please fill Item Name and Price");
//       return;
//     }
//     if (editingId) {
//       setMenu(menu.map((m) => (m.id === editingId ? { ...formData, id: editingId } : m)));
//     } else {
//       setMenu([...menu, { id: Date.now(), ...formData, price: Number(formData.price) }]);
//     }
//     closeModal();
//   };

//   const handleDelete = (id) => {
//     if (window.confirm("Delete this item?")) {
//       setMenu(menu.filter((item) => item.id !== id));
//     }
//   };

//   // Group by category
//   const categories = ["starters", "mains", "desserts", "drinks"];
//   const groupedMenu = {};
//   categories.forEach((cat) => {
//     groupedMenu[cat] = menu.filter((item) => item.category === cat);
//   });

//   return (
//     <div style={{ padding: 20, maxWidth: 1200, margin: "auto" }}>
//       <div style={{ marginBottom: 20, textAlign: "left" }}>
//         <button
//           onClick={() => openModal()}
//           style={{
//             padding: "10px 16px",
//             background: "#28a745",
//             color: "#fff",
//             border: "none",
//             borderRadius: 6,
//             fontWeight: "bold",
//             cursor: "pointer",
//           }}
//         >
//           + Add Menu Item
//         </button>
//       </div>

//       {categories.map((cat) =>
//         groupedMenu[cat].length > 0 ? (
//           <div key={cat} style={{ marginBottom: 30 }}>
//             <h2 style={{ textTransform: "capitalize" }}>{cat}</h2>
//             <div
//               style={{
//                 display: "grid",
//                 gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
//                 gap: 20,
//               }}
//             >
//               {groupedMenu[cat].map((item) => (
//                 <div
//                   key={item.id}
//                   style={{
//                     border: "1px solid #ddd",
//                     borderRadius: 12,
//                     padding: 15,
//                     background: "#fff",
//                     boxShadow: "0px 2px 6px rgba(0,0,0,0.08)",
//                     position: "relative",
//                   }}
//                 >
//                   {/* Veg / Non-Veg Badge + Actions */}
//                   <div
//                     style={{
//                       position: "absolute",
//                       top: 10,
//                       right: 10,
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 8,
//                     }}
//                   >
//                     <span
//                       style={{
//                         fontSize: 12,
//                         padding: "3px 8px",
//                         borderRadius: "12px",
//                         background: item.isVeg ? "#e6f4ea" : "#fdecea",
//                         color: item.isVeg ? "#137333" : "#b31412",
//                         fontWeight: "bold",
//                       }}
//                     >
//                       {item.isVeg ? "Veg" : "Non-Veg"}
//                     </span>
//                     <FaEdit
//                       style={{ cursor: "pointer", color: "#007bff" }}
//                       onClick={() => openModal(item)}
//                     />
//                     <FaTrash
//                       style={{ cursor: "pointer", color: "#dc3545" }}
//                       onClick={() => handleDelete(item.id)}
//                     />
//                   </div>

//                   {/* Item Info */}
//                   <h4 style={{ margin: "0 0 8px", fontWeight: "600" }}>{item.name}</h4>
//                   <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 8 }}>
//                     <span
//                       style={{
//                         fontSize: 12,
//                         background: "#f1f3f4",
//                         padding: "3px 10px",
//                         borderRadius: 12,
//                       }}
//                     >
//                       {item.category}
//                     </span>
//                     <span
//                       style={{
//                         fontSize: 12,
//                         background: "#f1f3f4",
//                         padding: "3px 10px",
//                         borderRadius: 12,
//                       }}
//                     >
//                       {item.cuisine || "General"}
//                     </span>
//                   </div>
//                   <p style={{ margin: 0, fontWeight: "bold", color: "#333" }}>₹{item.price}</p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         ) : null
//       )}

//       {/* Modal */}
//       <Modal
//         isOpen={isModalOpen}
//         onRequestClose={closeModal}
//         contentLabel="Add/Edit Menu Item"
//         style={{
//           content: {
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             maxWidth: "400px",
//             width: "90%",
//             borderRadius: "10px",
//             padding: "20px",
//           },
//         }}
//       >
//         <h2>{editingId ? "Edit Menu Item" : "Add New Menu Item"}</h2>

//         <label>Item Name</label>
//         <input
//           type="text"
//           name="name"
//           value={formData.name}
//           onChange={handleChange}
//           style={{ width: "100%", marginBottom: 10, padding: 8 }}
//         />

//         <label>Cuisine</label>
//         <input
//           type="text"
//           name="cuisine"
//           value={formData.cuisine}
//           onChange={handleChange}
//           style={{ width: "100%", marginBottom: 10, padding: 8 }}
//         />

//         <label>Category</label>
//         <select
//           name="category"
//           value={formData.category}
//           onChange={handleChange}
//           style={{ width: "100%", marginBottom: 10, padding: 8 }}
//         >
//           <option value="starters">Starters</option>
//           <option value="mains">Mains</option>
//           <option value="desserts">Desserts</option>
//           <option value="drinks">Drinks</option>
//         </select>

//         <label>Type</label>
//         <div style={{ marginBottom: 10 }}>
//           <label>
//             <input
//               type="radio"
//               name="isVeg"
//               value="true"
//               checked={formData.isVeg === true}
//               onChange={() => setFormData({ ...formData, isVeg: true })}
//             />{" "}
//             Veg
//           </label>{" "}
//           <label style={{ marginLeft: 20 }}>
//             <input
//               type="radio"
//               name="isVeg"
//               value="false"
//               checked={formData.isVeg === false}
//               onChange={() => setFormData({ ...formData, isVeg: false })}
//             />{" "}
//             Non-Veg
//           </label>
//         </div>

//         <label>Price</label>
//         <input
//           type="number"
//           name="price"
//           value={formData.price}
//           onChange={handleChange}
//           style={{ width: "100%", marginBottom: 15, padding: 8 }}
//         />

//         <div style={{ display: "flex", justifyContent: "space-between" }}>
//           <button
//             onClick={closeModal}
//             style={{
//               background: "#6c757d",
//               color: "#fff",
//               border: "none",
//               borderRadius: 5,
//               padding: "8px 14px",
//             }}
//           >
//             Cancel
//           </button>
//           <button
//             onClick={handleSave}
//             style={{
//               background: "#28a745",
//               color: "#fff",
//               border: "none",
//               borderRadius: 5,
//               padding: "8px 14px",
//             }}
//           >
//             {editingId ? "Update Item" : "Save Item"}
//           </button>
//         </div>
//       </Modal>
//     </div>
//   );
// }



// import React, { useState, useEffect } from "react";
// import { FaEdit, FaTrash, FaPlus } from "react-icons/fa";
// import Modal from "react-modal";
// import * as XLSX from "xlsx";
// import "./Custmizemenu.css";

// Modal.setAppElement("#root");



// export default function FoodMenuTable() {
//   const [menu, setMenu] = useState([]);
//   const [filterType, setFilterType] = useState("all");
//   const [isQuickModal, setIsQuickModal] = useState(false);
//   const [isDetailModal, setIsDetailModal] = useState(false);
//   const [editRowId, setEditRowId] = useState(null);

//   const [quickForm, setQuickForm] = useState({
//     name: "",
//     image: "",
//     type: "veg",
//   });

//   const [detailForm, setDetailForm] = useState({
//     id: null,
//     name: "",
//     category: "",
//     price: "",
//     quantity: "",
//     consumed: "",
//     chefType: "",
//     gst: 1,
//     packing: 1,
//     status: true,
//     image: "",
//     type: "veg",
//   });

//   // Load localStorage
//   useEffect(() => {
//     const saved = localStorage.getItem("menuData");
//     if (saved) setMenu(JSON.parse(saved));
//   }, []);

//   // Save to localStorage
//   useEffect(() => {
//     localStorage.setItem("menuData", JSON.stringify(menu));
//   }, [menu]);

//   // Quick form change
//   const handleQuickChange = (e) => {
//     const { name, value, files } = e.target;
//     if (name === "image" && files[0]) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setQuickForm({ ...quickForm, image: reader.result });
//       };
//       reader.readAsDataURL(files[0]);
//     } else {
//       setQuickForm({ ...quickForm, [name]: value });
//     }
//   };

//   // Detail form change
//   const handleDetailChange = (e) => {
//     const { name, value, type, checked, files } = e.target;
//     if (type === "file" && files[0]) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setDetailForm({ ...detailForm, image: reader.result });
//       };
//       reader.readAsDataURL(files[0]);
//     } else {
//       setDetailForm({
//         ...detailForm,
//         [name]: type === "checkbox" ? checked : value,
//       });
//     }
//   };

//   // Save Quick
//   const handleQuickSave = () => {
//     if (!quickForm.name) {
//       alert("Enter item name!");
//       return;
//     }
//     const newItem = {
//       ...quickForm,
//       id: Date.now(),
//       balance: 0,
//       category: "",
//       price: "",
//       quantity: "",
//       consumed: "",
//       chefType: "",
//       gst: 1,
//       packing: 1,
//       status: true,
//     };
//     setMenu([...menu, newItem]);
//     setQuickForm({ name: "", image: "", type: "veg" });
//     setIsQuickModal(false);
//   };

//   // Save detail
//   const handleDetailSave = () => {
//     const balance =
//       Number(detailForm.quantity || 0) - Number(detailForm.consumed || 0);

//     if (detailForm.id) {
//       setMenu(
//         menu.map((item) =>
//           item.id === detailForm.id ? { ...detailForm, balance } : item
//         )
//       );
//     } else {
//       setMenu([
//         ...menu,
//         {
//           ...detailForm,
//           id: Date.now(),
//           balance,
//         },
//       ]);
//     }

//     setDetailForm({
//       id: null,
//       name: "",
//       category: "",
//       price: "",
//       quantity: "",
//       consumed: "",
//       chefType: "",
//       gst: 1,
//       packing: 1,
//       status: true,
//       image: "",
//       type: "veg",
//     });
//     setIsDetailModal(false);
//   };

//   const handleDelete = (id) => {
//     if (window.confirm("Delete this item?")) {
//       setMenu(menu.filter((item) => item.id !== id));
//     }
//   };

//   const handleEdit = (item) => {
//     setDetailForm(item);
//     setIsDetailModal(true);
//     setEditRowId(item.id);
//   };

//   // Filter menu
//   const filteredMenu =
//     filterType === "all"
//       ? menu.filter((m) => m.status)
//       : menu.filter((m) => m.type === filterType && m.status);

//   // Export Excel
//   const handleExport = () => {
//     const ws = XLSX.utils.json_to_sheet(menu);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Menu");
//     XLSX.writeFile(wb, "menu.xlsx");
//   };

//   // Import Excel
//   const handleImport = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     const reader = new FileReader();
//     reader.onload = (evt) => {
//       const data = new Uint8Array(evt.target.result);
//       const workbook = XLSX.read(data, { type: "array" });
//       const ws = workbook.Sheets[workbook.SheetNames[0]];
//       const importedData = XLSX.utils.sheet_to_json(ws);
//       setMenu(importedData);
//     };
//     reader.readAsArrayBuffer(file);
//   };

//   return (
//     <div className="menu-container">


//       {/* Top Action Bar */}
//       <div className="top-bar">
//         <div className="left-side">
//           <button className="add-btn" onClick={() => setIsQuickModal(true)}>
//             <FaPlus /> Add Item
//           </button>
//         </div>

//         <div className="center-toggle">
//           <button
//             className={`toggle-btn ${filterType === "veg" ? "active" : ""}`}
//             onClick={() => setFilterType("veg")}
//           >
//             Veg
//           </button>
//           <button
//             className={`toggle-btn ${filterType === "nonveg" ? "active" : ""}`}
//             onClick={() => setFilterType("nonveg")}
//           >
//             Non-Veg
//           </button>
//           <button
//             className={`toggle-btn ${filterType === "all" ? "active" : ""}`}
//             onClick={() => setFilterType("all")}
//           >
//             All
//           </button>
//         </div>

//         <div className="menu-right-side">
//           <button className="menu-export-btn" onClick={handleExport}>
//             Export
//           </button>
//           <label className="menu-import-btn">
//             Import
//             <input type="file" onChange={handleImport} />
//           </label>
//         </div>




//       </div>

//       {/* Table */}
//       <div className="table-wrapper">
//         <table className="menu-table">
//           <thead>
//             <tr>
//               <th>S.No</th>
//               <th>Item</th>
//               <th>Image</th>
//               <th>Type</th>
//               <th>Price</th>
//               <th>Category</th>
//               <th>Quantity</th>
//               <th>Consumed</th>
//               <th>Balance</th>
//               <th>Chef Type</th>
//               <th>GST</th>
//               <th>Packing</th>
//               {/* <th>Status</th> */}
//               <th>Actions</th>
//               <th>Add Details</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredMenu.map((item, index) => (
//               <tr key={item.id}>
//                 <td>{index + 1}</td>
//                 <td>{item.name}</td>
//                 <td>
//                   {item.image ? (
//                     <img src={item.image} alt={item.name} className="item-img" />
//                   ) : (
//                     "No Image"
//                   )}
//                 </td>
//                 <td>{item.type}</td>
//                 <td>{item.price}</td>
//                 <td>{item.category}</td>
//                 <td>{item.quantity}</td>
//                 <td>{item.consumed}</td>
//                 <td>{item.balance}</td>
//                 <td>{item.chefType}</td>
//                 <td>{item.gst}</td>
//                 <td>{item.packing}</td>
//                 {/* <td>
//                   <label className="menu-status-toggle">
//                     <input
//                       type="checkbox"
//                       checked={item.status}
//                       onChange={() =>
//                         setMenu(
//                           menu.map((m) =>
//                             m.id === item.id ? { ...m, status: !m.status } : m
//                           )
//                         )
//                       }
//                     />
//                     <span className="menu-toggle-slider"></span>
//                     <span
//                       className={`menu-toggle-text ${item.status ? "show-text" : "hide-text"}`}
//                     >
//                       {item.status ? "Show" : "Hide"}
//                     </span>
//                   </label>
//                 </td> */}




//                 <td>
//                   <FaEdit
//                     className="action-icon edit"
//                     onClick={() => handleEdit(item)}
//                   />
//                   <FaTrash
//                     className="action-icon delete"
//                     onClick={() => handleDelete(item.id)}
//                   />
//                 </td>
//                 <td>
//                   <button
//                     className="row-add-btn"
//                     onClick={() => {
//                       setDetailForm(item);
//                       setIsDetailModal(true);
//                     }}
//                   >
//                     Add
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {/* Quick Add Modal */}
//       <Modal
//         isOpen={isQuickModal}
//         onRequestClose={() => setIsQuickModal(false)}
//         contentLabel="Quick Add Item"
//         className="quick-modal-content"
//         overlayClassName="modal-overlay"
//       >
//         <h3>Add Item (Quick)</h3>
//         <div className="form-group">
//           <input
//             type="text"
//             name="name"
//             placeholder="Item Name"
//             value={quickForm.name}
//             onChange={handleQuickChange}
//           />
//           <input type="file" name="image" onChange={handleQuickChange} />
//           <select name="type" value={quickForm.type} onChange={handleQuickChange}>
//             <option value="veg">Veg</option>
//             <option value="nonveg">Non-Veg</option>
//           </select>
//         </div>
//         <div className="modal-actions">
//           <button className="cancel-btn" onClick={() => setIsQuickModal(false)}>
//             Cancel
//           </button>
//           <button className="save-btn" onClick={handleQuickSave}>
//             Add
//           </button>
//         </div>
//       </Modal>

//       {/* Detail Add/Edit Modal */}
//       <Modal
//         isOpen={isDetailModal}
//         onRequestClose={() => setIsDetailModal(false)}
//         contentLabel="Detail Item"
//         className="detail-modal-content"
//         overlayClassName="modal-overlay"
//       >
//         <h3>{editRowId ? "Edit Item" : "Add Details"}</h3>
//         <div className="form-group">
//           <input
//             type="text"
//             name="name"
//             placeholder="Item Name"
//             value={detailForm.name}
//             onChange={handleDetailChange}
//           />
//           <input
//             type="text"
//             name="category"
//             placeholder="Category"
//             value={detailForm.category}
//             onChange={handleDetailChange}
//           />
//           <input
//             type="number"
//             name="price"
//             placeholder="Price"
//             value={detailForm.price}
//             onChange={handleDetailChange}
//           />
//           <input
//             type="number"
//             name="quantity"
//             placeholder="Quantity"
//             value={detailForm.quantity}
//             onChange={handleDetailChange}
//           />
//           <input
//             type="number"
//             name="consumed"
//             placeholder="Consumed"
//             value={detailForm.consumed}
//             onChange={handleDetailChange}
//           />
//           <input
//             type="text"
//             name="chefType"
//             placeholder="Chef Type"
//             value={detailForm.chefType}
//             onChange={handleDetailChange}
//           />
//           <input type="file" name="image" onChange={handleDetailChange} />
//           <select name="type" value={detailForm.type} onChange={handleDetailChange}>
//             <option value="veg">Veg</option>
//             <option value="nonveg">Non-Veg</option>
//           </select>

//         </div>
//         <div className="modal-actions">
//           <button className="cancel-btn" onClick={() => setIsDetailModal(false)}>
//             Cancel
//           </button>
//           <button className="save-btn" onClick={handleDetailSave}>
//             {editRowId ? "Update" : "Save"}
//           </button>
//         </div>
//       </Modal>
//     </div>
//   );
// }





// import React, { useState, useEffect } from "react";
// import { FaEdit, FaTrash, FaPlus } from "react-icons/fa";
// import Modal from "react-modal";
// import * as XLSX from "xlsx";
// import "./Custmizemenu.css";
// import DEFAULT_IMAGE from "../Catreingfolder/food.jpg";

// Modal.setAppElement("#root");

// export default function FoodMenuTable() {
//   const defaultMenu = [
//   // Mains - 2 items
//   {
//     id: 1,
//     name: "Paneer Butter Masala",
//     type: "veg",
//     image: "",
//     category: "Mains",
//     price: 250,
//     quantity: 10,
//     consumed: 0,
//     balance: 10,
//     chefType: "Indian",
//     gst: 5,
//     packing: 1,
//     status: true,
//   },
//   {
//     id: 2,
//     name: "Chicken Curry",
//     type: "nonveg",
//     image: "",
//     category: "Mains",
//     price: 300,
//     quantity: 12,
//     consumed: 0,
//     balance: 12,
//     chefType: "South Indian",
//     gst: 5,
//     packing: 1,
//     status: true,
//   },

//   // Starter - 2 items
//   {
//     id: 3,
//     name: "Veg Salad",
//     type: "veg",
//     image: "",
//     category: "Starter",
//     price: 120,
//     quantity: 20,
//     consumed: 0,
//     balance: 20,
//     chefType: "North Indian",
//     gst: 5,
//     packing: 1,
//     status: true,
//   },
//   {
//     id: 4,
//     name: "Paneer Tikka",
//     type: "veg",
//     image: "",
//     category: "Starter",
//     price: 180,
//     quantity: 15,
//     consumed: 0,
//     balance: 15,
//     chefType: "North Indian",
//     gst: 5,
//     packing: 1,
//     status: true,
//   },

//   // Drinks - 2 items
//   {
//     id: 5,
//     name: "Mango Lassi",
//     type: "veg",
//     image: "",
//     category: "Drinks",
//     price: 90,
//     quantity: 25,
//     consumed: 0,
//     balance: 25,
//     chefType: "Beverage",
//     gst: 5,
//     packing: 1,
//     status: true,
//   },
//   {
//     id: 6,
//     name: "Cold Coffee",
//     type: "veg",
//     image: "",
//     category: "Drinks",
//     price: 100,
//     quantity: 18,
//     consumed: 0,
//     balance: 18,
//     chefType: "Beverage",
//     gst: 5,
//     packing: 1,
//     status: true,
//   },

//   // Dessert - 2 items
//   {
//     id: 7,
//     name: "Gulab Jamun",
//     type: "veg",
//     image: "",
//     category: "Dessert",
//     price: 80,
//     quantity: 30,
//     consumed: 0,
//     balance: 30,
//     chefType: "North Indian",
//     gst: 5,
//     packing: 1,
//     status: true,
//   },
//   {
//     id: 8,
//     name: "Ice Cream Sundae",
//     type: "veg",
//     image: "",
//     category: "Dessert",
//     price: 150,
//     quantity: 12,
//     consumed: 0,
//     balance: 12,
//     chefType: "Western",
//     gst: 5,
//     packing: 1,
//     status: true,
//   },
// ];


//   const [menu, setMenu] = useState([]);
//   const [filterType, setFilterType] = useState("all");
//   const [isQuickModal, setIsQuickModal] = useState(false);
//   const [isDetailModal, setIsDetailModal] = useState(false);
//   const [editRowId, setEditRowId] = useState(null);


//   const [quickForm, setQuickForm] = useState({
//     name: "",
//     price: "",   // added
//     image: "",
//     type: "veg",
//   });
//   const [detailForm, setDetailForm] = useState({
//     id: null,
//     name: "",
//     category: "",
//     price: "",
//     quantity: "",
//     consumed: "",
//     chefType: "",
//     gst: 1,
//     packing: 1,
//     status: true,
//     image: "",
//     type: "veg",
//   });

//   // Load localStorage or default menu
//   useEffect(() => {
//     const saved = localStorage.getItem("menuData");
//     if (saved && JSON.parse(saved).length > 0) {
//       setMenu(JSON.parse(saved));
//     } else {
//       setMenu(defaultMenu); // default items load
//     }
//   }, []);

//   // Save to localStorage
//   useEffect(() => {
//     localStorage.setItem("menuData", JSON.stringify(menu));
//   }, [menu]);

//   // Quick form change
//   const handleQuickChange = (e) => {
//     const { name, value, files } = e.target;
//     if (name === "image" && files[0]) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setQuickForm({ ...quickForm, image: reader.result });
//       };
//       reader.readAsDataURL(files[0]);
//     } else {
//       setQuickForm({ ...quickForm, [name]: value });
//     }
//   };

//   // Detail form change
//   const handleDetailChange = (e) => {
//     const { name, value, type, checked, files } = e.target;
//     if (type === "file" && files[0]) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setDetailForm({ ...detailForm, image: reader.result });
//       };
//       reader.readAsDataURL(files[0]);
//     } else {
//       setDetailForm({
//         ...detailForm,
//         [name]: type === "checkbox" ? checked : value,
//       });
//     }
//   };

//   // Save Quick
//   const handleQuickSave = () => {
//     if (!quickForm.name) {
//       alert("Enter item name!");
//       return;
//     }
//     const newItem = {
//       ...quickForm,   // now includes price
//       id: Date.now(),
//       balance: 0,
//       category: "",
//       quantity: "",
//       consumed: "",
//       chefType: "",
//       gst: 1,
//       packing: 1,
//       status: true,
//     };
//     setMenu([...menu, newItem]);
//     setQuickForm({ name: "", price: "", image: "", type: "veg" });
//     setIsQuickModal(false);
//   };

//   // Save detail
//   const handleDetailSave = () => {
//     const balance =
//       Number(detailForm.quantity || 0) - Number(detailForm.consumed || 0);

//     if (detailForm.id) {
//       setMenu(
//         menu.map((item) =>
//           item.id === detailForm.id ? { ...detailForm, balance } : item
//         )
//       );
//     } else {
//       setMenu([
//         ...menu,
//         {
//           ...detailForm,
//           id: Date.now(),
//           balance,
//         },
//       ]);
//     }

//     setDetailForm({
//       id: null,
//       name: "",
//       category: "",
//       price: "",
//       quantity: "",
//       consumed: "",
//       chefType: "",
//       gst: 1,
//       packing: 1,
//       status: true,
//       image: "",
//       type: "veg",
//     });
//     setIsDetailModal(false);
//   };

//   const handleDelete = (id) => {
//     if (window.confirm("Delete this item?")) {
//       setMenu(menu.filter((item) => item.id !== id));
//     }
//   };

//   const handleEdit = (item) => {
//     setDetailForm(item);
//     setIsDetailModal(true);
//     setEditRowId(item.id);
//   };

//   // Filter menu (only by type, Show/Hide switch does not hide rows)
//   const filteredMenu =
//     filterType === "all"
//       ? menu
//       : menu.filter((m) => m.type === filterType);

//   // Export Excel
//   const handleExport = () => {
//     const ws = XLSX.utils.json_to_sheet(menu);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Menu");
//     XLSX.writeFile(wb, "menu.xlsx");
//   };

//   // Import Excel
//   const handleImport = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     const reader = new FileReader();
//     reader.onload = (evt) => {
//       const data = new Uint8Array(evt.target.result);
//       const workbook = XLSX.read(data, { type: "array" });
//       const ws = workbook.Sheets[workbook.SheetNames[0]];
//       const importedData = XLSX.utils.sheet_to_json(ws);
//       setMenu(importedData);
//     };
//     reader.readAsArrayBuffer(file);
//   };

//   return (
//     <div className="menu-container">

//       {/* Top Action Bar */}
//       <div className="top-bar">
//         <div className="left-side">
//           <button className="add-btn" onClick={() => setIsQuickModal(true)}>
//             <FaPlus /> Add Item
//           </button>
//         </div>

//         <div className="center-toggle">
//           <button
//             className={`toggle-btn ${filterType === "veg" ? "active" : ""}`}
//             onClick={() => setFilterType("veg")}
//           >
//             Veg
//           </button>
//           <button
//             className={`toggle-btn ${filterType === "nonveg" ? "active" : ""}`}
//             onClick={() => setFilterType("nonveg")}
//           >
//             Non-Veg
//           </button>
//           <button
//             className={`toggle-btn ${filterType === "all" ? "active" : ""}`}
//             onClick={() => setFilterType("all")}
//           >
//             All
//           </button>
//         </div>

//         <div className="menu-right-side">
//           <button className="menu-export-btn" onClick={handleExport}>
//             Export
//           </button>
//           <label className="menu-import-btn">
//             Import
//             <input type="file" onChange={handleImport} />
//           </label>
//         </div>
//       </div>

//       {/* Table */}
//       <div className="table-wrapper">
//         <table className="menu-table">
//           <thead>
//             <tr>
//               <th>S.No</th>
//               <th>Item</th>
//               <th>Image</th>
//               <th>Type</th>
//               <th>Price</th>
//               <th>Category</th>
//               {/* <th>Quantity</th> */}
//               {/* <th>Consumed</th> */}
//               {/* <th>Balance</th> */}
//               <th>Chef Type</th>
//               <th>GST</th>
//               {/* <th>Packing</th> */}
//               <th>Status</th>
//               <th>Actions</th>
//               <th>Add Details</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredMenu.map((item, index) => (
//               <tr key={item.id}>
//                 <td>{index + 1}</td>
//                 <td>{item.name}</td>
//                 <td>
//                   <img
//                     src={item.image || DEFAULT_IMAGE}
//                     alt={item.name}
//                     className="item-img"
//                   />
//                 </td>
//                 <td>{item.type}</td>
//                 <td>{item.price}</td>
//                 <td>{item.category}</td>
//                 {/* <td>{item.quantity}</td> */}
//                 {/* <td>{item.consumed}</td> */}
//                 {/* <td>{item.balance}</td> */}
//                 <td>{item.chefType}</td>
//                 <td>{item.gst}</td>
//                 {/* <td>{item.packing}</td> */}
//                 <td>
//                   <label className="menu-status-toggle">
//                     <input
//                       type="checkbox"
//                       checked={item.status}
//                       onChange={() =>
//                         setMenu(
//                           menu.map((m) =>
//                             m.id === item.id ? { ...m, status: !m.status } : m
//                           )
//                         )
//                       }
//                     />
//                     <span className="menu-toggle-slider"></span>
//                     <span
//                       className={`menu-toggle-text ${item.status ? "show-text" : "hide-text"
//                         }`}
//                     >
//                       {item.status ? "Show" : "Hide"}
//                     </span>
//                   </label>
//                 </td>
//                 <td>
//                   <FaEdit
//                     className="action-icon edit"
//                     onClick={() => handleEdit(item)}
//                   />
//                   <FaTrash
//                     className="action-icon delete"
//                     onClick={() => handleDelete(item.id)}
//                   />
//                 </td>
//                 <td>
//                   <button
//                     className="row-add-btn"
//                     onClick={() => {
//                       setDetailForm(item);
//                       setIsDetailModal(true);
//                     }}
//                   >
//                     Add
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {/* Quick Add Modal */}
//       <Modal
//         isOpen={isQuickModal}
//         onRequestClose={() => setIsQuickModal(false)}
//         contentLabel="Quick Add Item"
//         className="quick-modal-content"
//         overlayClassName="modal-overlay"
//       >
//         <h3>Add Item (Quick)</h3>
//         <div className="form-group">
//           <input
//             type="text"
//             name="name"
//             placeholder="Item Name"
//             value={quickForm.name}
//             onChange={handleQuickChange}
//           />
//           <input
//             type="number"
//             name="price"
//             placeholder="Price"
//             value={quickForm.price || ""}
//             onChange={handleQuickChange}
//           />
//           <input type="file" name="image" onChange={handleQuickChange} />
//           <select name="type" value={quickForm.type} onChange={handleQuickChange}>
//             <option value="veg">Veg</option>
//             <option value="nonveg">Non-Veg</option>
//           </select>
//         </div>
//         <div className="modal-actions">
//           <button className="cancel-btn" onClick={() => setIsQuickModal(false)}>
//             Cancel
//           </button>
//           <button className="save-btn" onClick={handleQuickSave}>
//             Add
//           </button>
//         </div>
//       </Modal>


//       {/* Detail Add/Edit Modal */}
//       <Modal
//         isOpen={isDetailModal}
//         onRequestClose={() => setIsDetailModal(false)}
//         contentLabel="Detail Item"
//         className="detail-modal-content"
//         overlayClassName="modal-overlay"
//       >
//         <h3>{editRowId ? "Edit Item" : "Add Details"}</h3>
//         <div className="form-group">
//           <input
//             type="text"
//             name="name"
//             placeholder="Item Name"
//             value={detailForm.name}
//             onChange={handleDetailChange}
//           />
//           <input
//             type="text"
//             name="category"
//             placeholder="Category"
//             value={detailForm.category}
//             onChange={handleDetailChange}
//           />
//           <input
//             type="number"
//             name="price"
//             placeholder="Price"
//             value={detailForm.price}
//             onChange={handleDetailChange}
//           />
//           <input
//             type="number"
//             name="quantity"
//             placeholder="Quantity"
//             value={detailForm.quantity}
//             onChange={handleDetailChange}
//           />
//           <input
//             type="number"
//             name="consumed"
//             placeholder="Consumed"
//             value={detailForm.consumed}
//             onChange={handleDetailChange}
//           />
//           <input
//             type="text"
//             name="chefType"
//             placeholder="Chef Type"
//             value={detailForm.chefType}
//             onChange={handleDetailChange}
//           />
//           <input type="file" name="image" onChange={handleDetailChange} />
//           <select name="type" value={detailForm.type} onChange={handleDetailChange}>
//             <option value="veg">Veg</option>
//             <option value="nonveg">Non-Veg</option>
//           </select>
//         </div>
//         <div className="modal-actions">
//           <button className="cancel-btn" onClick={() => setIsDetailModal(false)}>
//             Cancel
//           </button>
//           <button className="save-btn" onClick={handleDetailSave}>
//             {editRowId ? "Update" : "Save"}
//           </button>
//         </div>
//       </Modal>
//     </div>
//   );
// }






// import React, { useState, useEffect } from "react";
// import { FaEdit, FaTrash, FaPlus, FaHandPointer } from "react-icons/fa";
// import Modal from "react-modal";
// import * as XLSX from "xlsx";
// import "./Custmizemenu.css";
// import DEFAULT_IMAGE from "../Catreingfolder/food.jpg";

// Modal.setAppElement("#root");

// export default function FoodMenuTable() {
//   const defaultMenu = [
//     // Mains - 2 items
//     {
//       id: 1,
//       name: "Paneer Butter Masala",
//       type: "veg",
//       image: "",
//       category: "Mains",
//       price: 250,
//       quantity: 10,
//       consumed: 0,
//       balance: 10,
//       chefType: "Indian",
//       gst: 5,
//       packing: 1,
//       status: true,
//     },
//     {
//       id: 2,
//       name: "Chicken Curry",
//       type: "nonveg",
//       image: "",
//       category: "Mains",
//       price: 300,
//       quantity: 12,
//       consumed: 0,
//       balance: 12,
//       chefType: "South Indian",
//       gst: 5,
//       packing: 1,
//       status: true,
//     },

//     // Starter - 2 items
//     {
//       id: 3,
//       name: "Veg Salad",
//       type: "veg",
//       image: "",
//       category: "Starter",
//       price: 120,
//       quantity: 20,
//       consumed: 0,
//       balance: 20,
//       chefType: "North Indian",
//       gst: 5,
//       packing: 1,
//       status: true,
//     },
//     {
//       id: 4,
//       name: "Paneer Tikka",
//       type: "veg",
//       image: "",
//       category: "Starter",
//       price: 180,
//       quantity: 15,
//       consumed: 0,
//       balance: 15,
//       chefType: "North Indian",
//       gst: 5,
//       packing: 1,
//       status: true,
//     },

//     // Drinks - 2 items
//     {
//       id: 5,
//       name: "Mango Lassi",
//       type: "veg",
//       image: "",
//       category: "Drinks",
//       price: 90,
//       quantity: 25,
//       consumed: 0,
//       balance: 25,
//       chefType: "Beverage",
//       gst: 5,
//       packing: 1,
//       status: true,
//     },
//     {
//       id: 6,
//       name: "Cold Coffee",
//       type: "veg",
//       image: "",
//       category: "Drinks",
//       price: 100,
//       quantity: 18,
//       consumed: 0,
//       balance: 18,
//       chefType: "Beverage",
//       gst: 5,
//       packing: 1,
//       status: true,
//     },

//     // Dessert - 2 items
//     {
//       id: 7,
//       name: "Gulab Jamun",
//       type: "veg",
//       image: "",
//       category: "Dessert",
//       price: 80,
//       quantity: 30,
//       consumed: 0,
//       balance: 30,
//       chefType: "North Indian",
//       gst: 5,
//       packing: 1,
//       status: true,
//     },
//     {
//       id: 8,
//       name: "Ice Cream Sundae",
//       type: "veg",
//       image: "",
//       category: "Dessert",
//       price: 150,
//       quantity: 12,
//       consumed: 0,
//       balance: 12,
//       chefType: "Western",
//       gst: 5,
//       packing: 1,
//       status: true,
//     },
//   ];

//   const [menu, setMenu] = useState([]);
//   const [filterType, setFilterType] = useState("all");
//   const [showTypeDropdown, setShowTypeDropdown] = useState(false);

//   const [isQuickModal, setIsQuickModal] = useState(false);
//   const [isDetailModal, setIsDetailModal] = useState(false);
//   const [editRowId, setEditRowId] = useState(null);
//   const [isVegSelected, setIsVegSelected] = useState(null); // null = not selected yet

//   const [quickForm, setQuickForm] = useState({
//     name: "",
//     price: "",
//     image: "",
//     type: "veg",
//   });
//   const [detailForm, setDetailForm] = useState({
//     id: null,
//     name: "",
//     category: "",
//     price: "",
//     quantity: "",
//     consumed: "",
//     chefType: "",
//     gst: 1,
//     packing: 1,
//     status: true,
//     image: "",
//     type: "veg",
//   });


//   const handleFilterClick = (type) => {
//     if (type === "Veg") {
//       setIsVegSelected(true);
//     } else if (type === "Non-Veg") {
//       setIsVegSelected(false);
//     }
//   };

//   // Load localStorage or default menu
//   useEffect(() => {
//     const saved = localStorage.getItem("menuData");
//     if (saved && JSON.parse(saved).length > 0) {
//       setMenu(JSON.parse(saved));
//     } else {
//       setMenu(defaultMenu); // default items load
//     }
//   }, []);

//   // Save to localStorage
//   useEffect(() => {
//     localStorage.setItem("menuData", JSON.stringify(menu));
//   }, [menu]);

//   // Quick form change
//   const handleQuickChange = (e) => {
//     const { name, value, files } = e.target;
//     if (name === "image" && files[0]) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setQuickForm({ ...quickForm, image: reader.result });
//       };
//       reader.readAsDataURL(files[0]);
//     } else {
//       setQuickForm({ ...quickForm, [name]: value });
//     }
//   };

//   // Detail form change
//   const handleDetailChange = (e) => {
//     const { name, value, type, checked, files } = e.target;
//     if (type === "file" && files[0]) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setDetailForm({ ...detailForm, image: reader.result });
//       };
//       reader.readAsDataURL(files[0]);
//     } else {
//       setDetailForm({
//         ...detailForm,
//         [name]: type === "checkbox" ? checked : value,
//       });
//     }
//   };

//   // Save Quick
//   const handleQuickSave = () => {
//     if (!quickForm.name) {
//       alert("Enter item name!");
//       return;
//     }
//     const newItem = {
//       ...quickForm,
//       id: Date.now(),
//       balance: 0,
//       category: "",
//       quantity: "",
//       consumed: "",
//       chefType: "",
//       gst: 1,
//       packing: 1,
//       status: true,
//     };
//     setMenu([...menu, newItem]);
//     setQuickForm({ name: "", price: "", image: "", type: "veg" });
//     setIsQuickModal(false);
//   };

//   // Save detail
//   const handleDetailSave = () => {
//     const balance =
//       Number(detailForm.quantity || 0) - Number(detailForm.consumed || 0);

//     if (detailForm.id) {
//       setMenu(
//         menu.map((item) =>
//           item.id === detailForm.id ? { ...detailForm, balance } : item
//         )
//       );
//     } else {
//       setMenu([...menu, { ...detailForm, id: Date.now(), balance }]);
//     }

//     setDetailForm({
//       id: null,
//       name: "",
//       category: "",
//       price: "",
//       quantity: "",
//       consumed: "",
//       chefType: "",
//       gst: 1,
//       packing: 1,
//       status: true,
//       image: "",
//       type: "veg",
//     });
//     setIsDetailModal(false);
//   };

//   const handleDelete = (id) => {
//     if (window.confirm("Delete this item?")) {
//       setMenu(menu.filter((item) => item.id !== id));
//     }
//   };

//   const handleEdit = (item) => {
//     setDetailForm(item);
//     setIsDetailModal(true);
//     setEditRowId(item.id);
//   };

//   // Filter menu
//   const filteredMenu =
//     filterType === "all" ? menu : menu.filter((m) => m.type === filterType);

//   // Export Excel
//   const handleExport = () => {
//     const ws = XLSX.utils.json_to_sheet(menu);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Menu");
//     XLSX.writeFile(wb, "menu.xlsx");
//   };

//   // Import Excel
//   const handleImport = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     const reader = new FileReader();
//     reader.onload = (evt) => {
//       const data = new Uint8Array(evt.target.result);
//       const workbook = XLSX.read(data, { type: "array" });
//       const ws = workbook.Sheets[workbook.SheetNames[0]];
//       const importedData = XLSX.utils.sheet_to_json(ws);
//       setMenu(importedData);
//     };
//     reader.readAsArrayBuffer(file);
//   };

//   const tableHeaderStyle = {
//   backgroundColor: "#f5f5f5",
//   fontWeight: "bold",
//   fontSize: "13px",
// };

//   return (
//     <div className="menu-container">
//       {/* Top Bar (only left & right, no veg/nonveg buttons) */}
//       <div className="top-bar">
//         <div className="left-side">
//           <button className="add-btn" onClick={() => setIsQuickModal(true)}>
//             <FaPlus /> Add Item
//           </button>
//         </div>

//         <div className="menu-right-side">
//           <button className="menu-export-btn" onClick={handleExport}>
//             Export
//           </button>
//           <label className="menu-import-btn">
//             Import
//             <input type="file" onChange={handleImport} />
//           </label>
//         </div>
//       </div>

//       {/* Table */}
//       <div className="table-wrapper">
//         <table className="menu-table">
//           <thead>
//             <tr>
//               <th>S.No</th>
//               <th>Item</th>
//               <th>Image</th>
//                <th
//             style={{
//               ...tableHeaderStyle,
//               textAlign: "center",
//               padding: "8px",
//             }}
//           >
//             <div
//               style={{
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 gap: "6px",
//               }}
//             >
//               {/* Toggle Switch with Text Inside */}
//               <div
//                 onClick={() => {
//                   // If nothing is selected yet, make Veg the default on first click
//                   if (isVegSelected === null) {
//                     handleFilterClick("Veg");
//                   } else {
//                     handleFilterClick(isVegSelected ? "Non-Veg" : "Veg");
//                   }
//                 }}
//                 style={{
//                   width: "70px",
//                   height: "22px",
//                   borderRadius: "20px",
//                   backgroundColor:
//                     isVegSelected === null
//                       ? "#888" // neutral gray before selection
//                       : isVegSelected
//                       ? "green"
//                       : "red",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent:
//                     isVegSelected === null
//                       ? "center"
//                       : isVegSelected
//                       ? "flex-start"
//                       : "flex-end",
//                   cursor: "pointer",
//                   transition: "all 0.3s ease",
//                   position: "relative",
//                   color: "white",
//                   fontSize: "11px",
//                   fontWeight: "bold",
//                   padding: "0 6px",
//                 }}
//               >
//                 {/* Sliding circle */}
//                 {isVegSelected !== null && (
//                   <div
//                     style={{
//                       width: "18px",
//                       height: "18px",
//                       borderRadius: "50%",
//                       backgroundColor: "#fff",
//                       position: "absolute",
//                       left: isVegSelected ? "3px" : "calc(100% - 21px)",
//                       top: "2px",
//                       transition: "all 0.3s ease",
//                       boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
//                     }}
//                   />
//                 )}
//                 {/* Text inside toggle */}
//                 <span
//                   style={{ width: "100%", textAlign: "center", zIndex: 1 }}
//                 >
//                   {isVegSelected === null
//                     ? "Type"
//                     : isVegSelected
//                     ? "Veg"
//                     : "Non-Veg"}
//                 </span>
//               </div>
//             </div>
//           </th>

//               <th>Price</th>
//               <th>Category</th>
//               <th>Chef Type</th>
//               <th>GST</th>
//               <th>Status</th>
//               <th>Actions</th>
//               <th>Add Details</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredMenu.map((item, index) => (
//               <tr key={item.id}>
//                 <td>{index + 1}</td>
//                 <td>{item.name}</td>
//                 <td>
//                   <img
//                     src={item.image || DEFAULT_IMAGE}
//                     alt={item.name}
//                     className="item-img"
//                   />
//                 </td>
//                 <td>{item.type}</td>
//                 <td>{item.price}</td>
//                 <td>{item.category}</td>
//                 <td>{item.chefType}</td>
//                 <td>{item.gst}</td>
//                 <td>
//                   <label className="menu-status-toggle">
//                     <input
//                       type="checkbox"
//                       checked={item.status}
//                       onChange={() =>
//                         setMenu(
//                           menu.map((m) =>
//                             m.id === item.id ? { ...m, status: !m.status } : m
//                           )
//                         )
//                       }
//                     />
//                     <span className="menu-toggle-slider"></span>
//                     <span
//                       className={`menu-toggle-text ${item.status ? "show-text" : "hide-text"
//                         }`}
//                     >
//                       {item.status ? "Show" : "Hide"}
//                     </span>
//                   </label>
//                 </td>
//                 <td>
//                   <FaEdit
//                     className="action-icon edit"
//                     onClick={() => handleEdit(item)}
//                   />
//                   <FaTrash
//                     className="action-icon delete"
//                     onClick={() => handleDelete(item.id)}
//                   />
//                 </td>
//                 <td>
//                   <button
//                     className="row-add-btn"
//                     onClick={() => {
//                       setDetailForm(item);
//                       setIsDetailModal(true);
//                     }}
//                   >
//                     Add
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {/* Quick Add Modal */}
//       <Modal
//         isOpen={isQuickModal}
//         onRequestClose={() => setIsQuickModal(false)}
//         contentLabel="Quick Add Item"
//         className="quick-modal-content"
//         overlayClassName="modal-overlay"
//       >
//         <h3>Add Item (Quick)</h3>
//         <div className="form-group">
//           <input
//             type="text"
//             name="name"
//             placeholder="Item Name"
//             value={quickForm.name}
//             onChange={handleQuickChange}
//           />
//           <input
//             type="number"
//             name="price"
//             placeholder="Price"
//             value={quickForm.price || ""}
//             onChange={handleQuickChange}
//           />
//           <input type="file" name="image" onChange={handleQuickChange} />
//           <select name="type" value={quickForm.type} onChange={handleQuickChange}>
//             <option value="veg">Veg</option>
//             <option value="nonveg">Non-Veg</option>
//           </select>
//         </div>
//         <div className="modal-actions">
//           <button className="cancel-btn" onClick={() => setIsQuickModal(false)}>
//             Cancel
//           </button>
//           <button className="save-btn" onClick={handleQuickSave}>
//             Add
//           </button>
//         </div>
//       </Modal>

//       {/* Detail Add/Edit Modal */}
//       <Modal
//         isOpen={isDetailModal}
//         onRequestClose={() => setIsDetailModal(false)}
//         contentLabel="Detail Item"
//         className="detail-modal-content"
//         overlayClassName="modal-overlay"
//       >
//         <h3>{editRowId ? "Edit Item" : "Add Details"}</h3>
//         <div className="form-group">
//           <input
//             type="text"
//             name="name"
//             placeholder="Item Name"
//             value={detailForm.name}
//             onChange={handleDetailChange}
//           />
//           <input
//             type="text"
//             name="category"
//             placeholder="Category"
//             value={detailForm.category}
//             onChange={handleDetailChange}
//           />
//           <input
//             type="number"
//             name="price"
//             placeholder="Price"
//             value={detailForm.price}
//             onChange={handleDetailChange}
//           />
//           <input
//             type="number"
//             name="quantity"
//             placeholder="Quantity"
//             value={detailForm.quantity}
//             onChange={handleDetailChange}
//           />
//           <input
//             type="number"
//             name="consumed"
//             placeholder="Consumed"
//             value={detailForm.consumed}
//             onChange={handleDetailChange}
//           />
//           <input
//             type="text"
//             name="chefType"
//             placeholder="Chef Type"
//             value={detailForm.chefType}
//             onChange={handleDetailChange}
//           />
//           <input type="file" name="image" onChange={handleDetailChange} />
//           <select name="type" value={detailForm.type} onChange={handleDetailChange}>
//             <option value="veg">Veg</option>
//             <option value="nonveg">Non-Veg</option>
//           </select>
//         </div>
//         <div className="modal-actions">
//           <button className="cancel-btn" onClick={() => setIsDetailModal(false)}>
//             Cancel
//           </button>
//           <button className="save-btn" onClick={handleDetailSave}>
//             {editRowId ? "Update" : "Save"}
//           </button>
//         </div>
//       </Modal>
//     </div>
//   );
// }





import React, { useState, useEffect } from "react";
import { FaEdit, FaTrash, FaPlus } from "react-icons/fa";
import Modal from "react-modal";
import * as XLSX from "xlsx";
import "./Custmizemenu.css";
import DEFAULT_IMAGE from "../Catreingfolder/food.jpg";

Modal.setAppElement("#root");

export default function FoodMenuTable() {
  const defaultMenu = [
    { id: 1, name: "Paneer Butter Masala", type: "veg", image: "", category: "Mains", price: 250, quantity: 10, consumed: 0, balance: 10, chefType: "Indian", gst: 5, packing: 1, status: true },
    { id: 2, name: "Chicken Curry", type: "nonveg", image: "", category: "Mains", price: 300, quantity: 12, consumed: 0, balance: 12, chefType: "South Indian", gst: 5, packing: 1, status: true },
    { id: 3, name: "Veg Salad", type: "veg", image: "", category: "Starter", price: 120, quantity: 20, consumed: 0, balance: 20, chefType: "North Indian", gst: 5, packing: 1, status: true },
    { id: 4, name: "Paneer Tikka", type: "veg", image: "", category: "Starter", price: 180, quantity: 15, consumed: 0, balance: 15, chefType: "North Indian", gst: 5, packing: 1, status: true },
    { id: 5, name: "Mango Lassi", type: "veg", image: "", category: "Drinks", price: 90, quantity: 25, consumed: 0, balance: 25, chefType: "Beverage", gst: 5, packing: 1, status: true },
    { id: 6, name: "Cold Coffee", type: "veg", image: "", category: "Drinks", price: 100, quantity: 18, consumed: 0, balance: 18, chefType: "Beverage", gst: 5, packing: 1, status: true },
    { id: 7, name: "Gulab Jamun", type: "veg", image: "", category: "Dessert", price: 80, quantity: 30, consumed: 0, balance: 30, chefType: "North Indian", gst: 5, packing: 1, status: true },
    { id: 8, name: "Ice Cream Sundae", type: "veg", image: "", category: "Dessert", price: 150, quantity: 12, consumed: 0, balance: 12, chefType: "Western", gst: 5, packing: 1, status: true },
  ];

  const [menu, setMenu] = useState([]);
  const [isVegSelected, setIsVegSelected] = useState(null); // null = not selected yet
  const [isQuickModal, setIsQuickModal] = useState(false);
  const [isDetailModal, setIsDetailModal] = useState(false);
  const [editRowId, setEditRowId] = useState(null);

  const [quickForm, setQuickForm] = useState({ name: "", price: "", image: "", type: "veg" });
  const [detailForm, setDetailForm] = useState({
    id: null, name: "", category: "", price: "", quantity: "", consumed: "",
    chefType: "", gst: 1, packing: 1, status: true, image: "", type: "veg"
  });

  // Load from storage
  useEffect(() => {
    const saved = localStorage.getItem("menuData");
    if (saved && JSON.parse(saved).length > 0) setMenu(JSON.parse(saved));
    else setMenu(defaultMenu);
  }, []);

  // Save to storage
  useEffect(() => {
    localStorage.setItem("menuData", JSON.stringify(menu));
  }, [menu]);

  // Quick Add
  const handleQuickChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "image" && files[0]) {
      const reader = new FileReader();
      reader.onloadend = () => setQuickForm({ ...quickForm, image: reader.result });
      reader.readAsDataURL(files[0]);
    } else {
      setQuickForm({ ...quickForm, [name]: value });
    }
  };

  const handleQuickSave = () => {
    if (!quickForm.name) {
      alert("Enter item name!");
      return;
    }
    const newItem = {
      ...quickForm, id: Date.now(), balance: 0, category: "", quantity: "",
      consumed: "", chefType: "", gst: 1, packing: 1, status: true,
    };
    setMenu([...menu, newItem]);
    setQuickForm({ name: "", price: "", image: "", type: "veg" });
    setIsQuickModal(false);
  };

  // Detail Add/Edit
  const handleDetailChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (type === "file" && files[0]) {
      const reader = new FileReader();
      reader.onloadend = () => setDetailForm({ ...detailForm, image: reader.result });
      reader.readAsDataURL(files[0]);
    } else {
      setDetailForm({ ...detailForm, [name]: type === "checkbox" ? checked : value });
    }
  };

  const handleDetailSave = () => {
    const balance = Number(detailForm.quantity || 0) - Number(detailForm.consumed || 0);
    if (detailForm.id) {
      setMenu(menu.map((item) => (item.id === detailForm.id ? { ...detailForm, balance } : item)));
    } else {
      setMenu([...menu, { ...detailForm, id: Date.now(), balance }]);
    }
    setDetailForm({ id: null, name: "", category: "", price: "", quantity: "", consumed: "", chefType: "", gst: 1, packing: 1, status: true, image: "", type: "veg" });
    setIsDetailModal(false);
  };

  // Actions
  const handleDelete = (id) => {
    if (window.confirm("Delete this item?")) setMenu(menu.filter((item) => item.id !== id));
  };
  const handleEdit = (item) => {
    setDetailForm(item);
    setIsDetailModal(true);
    setEditRowId(item.id);
  };

  // Export Excel
  const handleExport = () => {
    const ws = XLSX.utils.json_to_sheet(menu);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Menu");
    XLSX.writeFile(wb, "menu.xlsx");
  };

  // Import Excel
  const handleImport = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (evt) => {
      const data = new Uint8Array(evt.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const ws = workbook.Sheets[workbook.SheetNames[0]];
      const importedData = XLSX.utils.sheet_to_json(ws);
      setMenu(importedData);
    };
    reader.readAsArrayBuffer(file);
  };

  // Toggle handler
  const handleFilterClick = (type) => {
    if (type === "Veg") setIsVegSelected(true);
    else if (type === "Non-Veg") setIsVegSelected(false);
  };

  // Filter data
  const filteredMenu =
    isVegSelected === null
      ? menu
      : menu.filter((m) => (isVegSelected ? m.type === "veg" : m.type === "nonveg"));

  return (
    <div className="menu-container">
      {/* Top Bar */}
      <div className="top-bar">
        <div className="left-side">
          <button className="add-btn" onClick={() => setIsQuickModal(true)}>
            <FaPlus /> Add Item
          </button>
        </div>
        <div className="menu-right-side">
          <button className="menu-export-btn" onClick={handleExport}>Export</button>
          <label className="menu-import-btn">
            Import
            <input type="file" hidden onChange={handleImport} />
          </label>
        </div>
      </div>

      {/* Table */}
      <div className="table-wrapper">
        <table className="menu-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Item</th>
              <th>Image</th>
              <th>
                <div
                  onClick={() => {
                    if (isVegSelected === null) handleFilterClick("Veg");
                    else handleFilterClick(isVegSelected ? "Non-Veg" : "Veg");
                  }}
                  className="veg-toggle"
                  style={{
                    backgroundColor: isVegSelected === null ? "#888" : isVegSelected ? "green" : "red",
                  }}
                >
                  {isVegSelected === null ? "Type" : isVegSelected ? "Veg" : "Non-Veg"}
                </div>
              </th>
              <th>Price</th>
              <th>Category</th>
              <th>Chef Type</th>
              <th>GST</th>
              <th>Status</th>
              <th>Actions</th>
              <th>Add Details</th>
            </tr>
          </thead>
          <tbody>
            {filteredMenu.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{item.name}</td>
                <td><img src={item.image || DEFAULT_IMAGE} alt={item.name} className="item-img" /></td>
                <td>{item.type}</td>
                <td>{item.price}</td>
                <td>{item.category}</td>
                <td>{item.chefType}</td>
                <td>{item.gst}</td>
                <td>
                  <label className="menu-status-toggle">
                    <input
                      type="checkbox"
                      checked={item.status}
                      onChange={() =>
                        setMenu(menu.map((m) => (m.id === item.id ? { ...m, status: !m.status } : m)))
                      }
                    />
                    <span className="menu-toggle-slider"></span>
                    <span className={`menu-toggle-text ${item.status ? "show-text" : "hide-text"}`}>
                      {item.status ? "Show" : "Hide"}
                    </span>
                  </label>
                </td>
                <td>
                  <FaEdit className="action-icon edit" onClick={() => handleEdit(item)} />
                  <FaTrash className="action-icon delete" onClick={() => handleDelete(item.id)} />
                </td>
                <td>
                  <button className="row-add-btn" onClick={() => { setDetailForm(item); setIsDetailModal(true); }}>
                    Add
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Quick Add Modal */}
      <Modal isOpen={isQuickModal} onRequestClose={() => setIsQuickModal(false)} className="quick-modal-content" overlayClassName="modal-overlay">
        <h3>Add Item (Quick)</h3>
        <div className="form-group">
          <input type="text" name="name" placeholder="Item Name" value={quickForm.name} onChange={handleQuickChange} />
          <input type="number" name="price" placeholder="Price" value={quickForm.price || ""} onChange={handleQuickChange} />
          <input type="file" name="image" onChange={handleQuickChange} />
          <select name="type" value={quickForm.type} onChange={handleQuickChange}>
            <option value="veg">Veg</option>
            <option value="nonveg">Non-Veg</option>
          </select>
        </div>
        <div className="modal-actions">
          <button className="cancel-btn" onClick={() => setIsQuickModal(false)}>Cancel</button>
          <button className="save-btn" onClick={handleQuickSave}>Add</button>
        </div>
      </Modal>

      {/* Detail Modal */}
      <Modal isOpen={isDetailModal} onRequestClose={() => setIsDetailModal(false)} className="detail-modal-content" overlayClassName="modal-overlay">
        <h3>{editRowId ? "Edit Item" : "Add Details"}</h3>
        <div className="form-group">
          <input type="text" name="name" placeholder="Item Name" value={detailForm.name} onChange={handleDetailChange} />
          <input type="text" name="category" placeholder="Category" value={detailForm.category} onChange={handleDetailChange} />
          <input type="number" name="price" placeholder="Price" value={detailForm.price} onChange={handleDetailChange} />
          <input type="number" name="quantity" placeholder="Quantity" value={detailForm.quantity} onChange={handleDetailChange} />
          <input type="number" name="consumed" placeholder="Consumed" value={detailForm.consumed} onChange={handleDetailChange} />
          <input type="text" name="chefType" placeholder="Chef Type" value={detailForm.chefType} onChange={handleDetailChange} />
          <input type="file" name="image" onChange={handleDetailChange} />
          <select name="type" value={detailForm.type} onChange={handleDetailChange}>
            <option value="veg">Veg</option>
            <option value="nonveg">Non-Veg</option>
          </select>
        </div>
        <div className="modal-actions">
          <button className="cancel-btn" onClick={() => setIsDetailModal(false)}>Cancel</button>
          <button className="save-btn" onClick={handleDetailSave}>{editRowId ? "Update" : "Save"}</button>
        </div>
      </Modal>
    </div>
  );
}
